import React, { useState, useEffect, useCallback } from 'react'
import { useNavigate, useLocation } from "react-router-dom";

const useNavigationGuard = (shouldBlock) => {
    const [showDialog, setShowDialog] = useState(false);
    const [pendingLocation, setPendingLocation] = useState(null);
    const navigate = useNavigate();

    // Handle navigation attempts
    const handleNavigationAttempt = useCallback((targetPath) => {
        if (shouldBlock) {
            setPendingLocation(targetPath);
            console.log("setting dialog to true")
            setShowDialog(true);
        } else {
            navigate(targetPath);
        }
    }, [shouldBlock, navigate]);

    // Handle dialog actions
    const handleConfirm = useCallback(() => {
        if (pendingLocation) {
            setShowDialog(false);
            setPendingLocation(null);
            navigate(pendingLocation);
        }
    }, [navigate, pendingLocation]);

    const handleCancel = useCallback(() => {
        setShowDialog(false);
        setPendingLocation(null);
    }, []);

    // Handle browser back button
    useEffect(() => {
        const handlePopState = (event) => {
            if (shouldBlock) {
                event.preventDefault();
                handleNavigationAttempt('/dashboard');
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, [shouldBlock, handleNavigationAttempt]);

    return {
        showDialog,
        setShowDialog,
        handleConfirm,
        handleCancel,
        handleNavigationAttempt,
    };
}

export default useNavigationGuard